
export default function HowItWorks() {
  const steps = [
    {
      step: 'Step 1',
      icon: 'ri-search-line',
      title: 'Free Digital Review',
      description: 'We audit your website, Google Business Profile, and online presence. No login needed, we use public information only.',
      delivery: 'Delivered within 48 hours'
    },
    {
      step: 'Step 2',
      icon: 'ri-line-chart-line',
      title: 'Monthly Insights',
      description: 'Clear reports showing what\'s working and what to fix. Track your progress and stay ahead of competitors.',
      delivery: 'Updated every month'
    },
    {
      step: 'Step 3',
      icon: 'ri-lightbulb-line',
      title: 'Strategy That Fits',
      description: 'Actionable plans to attract higher-margin work. Tailored to your business, not cookie-cutter templates.',
      delivery: 'Practical and achievable'
    }
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B35]/5 border border-[#FF6B35]/20 rounded-full text-sm mb-6">
            <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full"></span>
            <span className="text-[#1A1F36] font-medium">Simple Process</span>
          </div>
          <h2 className="text-4xl lg:text-[38px] font-bold text-[#1A1F36]">
            Three Steps to <span className="text-[#FF6B35]">Better Leads</span>
          </h2>
        </div>

        <div className="relative">
          {/* Connecting Line */}
          <div className="absolute left-[40px] top-[40px] bottom-[40px] w-0.5 bg-gradient-to-b from-[#FF6B35] via-[#FF6B35]/50 to-[#FF6B35]/20 hidden md:block"></div>

          <div className="space-y-10">
            {steps.map((item, index) => (
              <div key={index} className="relative flex gap-8 items-start group">
                {/* Icon Circle */}
                <div className="flex-shrink-0 w-20 h-20 bg-white border-2 border-[#FF6B35] rounded-full flex items-center justify-center z-10 group-hover:bg-[#FF6B35] transition-all duration-300">
                  <i className={`${item.icon} text-3xl text-[#FF6B35] group-hover:text-white transition-colors duration-300`}></i>
                </div>

                {/* Content */}
                <div className="flex-1 bg-[#FAFBFC] rounded-2xl p-8 group-hover:shadow-lg transition-all duration-300">
                  <div className="text-xs uppercase tracking-wider text-[#FF6B35] font-bold mb-2">
                    {item.step}
                  </div>
                  <h3 className="text-2xl font-bold text-[#1A1F36] mb-3">
                    {item.title}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed mb-4">
                    {item.description}
                  </p>
                  <div className="flex items-center gap-2 text-sm font-medium text-[#1A1F36]">
                    <div className="w-5 h-5 rounded-full bg-[#FF6B35]/10 flex items-center justify-center">
                      <i className="ri-check-line text-[#FF6B35] text-xs"></i>
                    </div>
                    {item.delivery}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
